export const GET_MESSAGES_SUCCESS = 'GET_MESSAGES_SUCCESS';
export const READ_MESSAGES_SUCCESS = 'READ_MESSAGES_SUCCESS';
export const READ_ALL_MESSAGES_SUCCESS = 'READ_ALL_MESSAGES_SUCCESS';
export const LOADING_MESSAGE = '请稍等...';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const ITEMS_PER_PAGE = 10;
export const GET_IM_TOKEN_SUCCESS = 'GET_IM_TOKEN_SUCCESS';
